import React, { useState, useEffect } from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import "./OvertimeApplication.css";
import "./AttendanceSummary.css";
import AttendanceSummaryLayout from "../layouts/Employee/AttendanceSummary";

function AttendanceSummary() {
  return (
    <div className="overtime-application-bg">
      <Header />
      <SubHeader />
      <AttendanceSummaryLayout />
    </div>
  );
}

export default AttendanceSummary;
